import { render, staticRenderFns } from "./StudentPunishment.vue?vue&type=template&id=f688729e&scoped=true&"
import script from "./StudentPunishment.vue?vue&type=script&lang=js&"
export * from "./StudentPunishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f688729e",
  null
  
)

export default component.exports